// src/pages/ClientData/components/ClientDataSection.js
import React, { useState } from 'react';
import CollapsibleSection from './CollapsibleSection';

const ClientDataSection = ({ clientData }) => {
  const [showOnlyPopulated, setShowOnlyPopulated] = useState(true);

  if (!clientData) return null;

  return (
    <CollapsibleSection title="Dados do Cliente" icon="👤" defaultOpen={false}>
      <div className="display-options">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={showOnlyPopulated}
            onChange={() => setShowOnlyPopulated(!showOnlyPopulated)}
          />
          <span className="toggle-slider"></span>
          Mostrar apenas campos preenchidos
        </label>
      </div>

      <div className="data-fields">
        {Object.entries(clientData).map(([key, value]) => {
          if (showOnlyPopulated && (value === null || value === undefined || value === '')) {
            return null;
          }

          return (
            <div className="data-field" key={key}>
              <div className="field-key">{key}</div>
              <div className="field-value">
                {typeof value === 'string' && value.length > 150
                  ? value.substring(0, 150) + '...'
                  : String(value)}
              </div>
            </div>
          );
        })}
      </div>
    </CollapsibleSection>
  );
};

export default ClientDataSection;
